// NCG Website Configuration
// This file manages all URLs for different environments

const config = {
  // Environment detection - more reliable for production builds
  isDevelopment:
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1",
  isProduction:
    window.location.hostname !== "localhost" &&
    window.location.hostname !== "127.0.0.1",

  // Base URLs for different environments
  development: {
    baseUrl: "http://localhost:3000",
    basePath: "",
    apiBaseUrl: "http://localhost/ncg_website/api",
    imagesBaseUrl: "/images",
    adminApiBaseUrl: "http://localhost/ncg_website/api/admin",
  },

  production: {
    baseUrl: "https://www.ncgcorporate.com",
    basePath: "",
    apiBaseUrl: "/api",
    imagesBaseUrl: "/images",
    adminApiBaseUrl: "/api/admin",
  },

  // Fallback mode (when API is not available)
  useFallbackData: process.env.NODE_ENV === "development",

  // Get current environment config
  getCurrentConfig() {
    return this.isDevelopment ? this.development : this.production;
  },

  getBasePath() {
    return this.getCurrentConfig().basePath;
  },

  // Helper methods to get URLs
  getApiUrl(endpoint = "") {
    const currentConfig = this.getCurrentConfig();
    return `${currentConfig.apiBaseUrl}/${endpoint}`
      .replace(/\/+/g, "/")
      .replace(":/", "://");
  },

  getAdminApiUrl(endpoint = "") {
    const currentConfig = this.getCurrentConfig();
    return `${currentConfig.adminApiBaseUrl}/${endpoint}`
      .replace(/\/+/g, "/")
      .replace(":/", "://");
  },

  getImageUrl(imagePath = "") {
    const currentConfig = this.getCurrentConfig();
    const cleanImagePath = imagePath.startsWith("/")
      ? imagePath.slice(1)
      : imagePath;
    return `${currentConfig.imagesBaseUrl}/${cleanImagePath}`.replace(
      /\/+/g,
      "/"
    );
  },

  getBaseUrl() {
    return this.getCurrentConfig().baseUrl;
  },

  getPageUrl(path = "") {
    const cleanPath = path.startsWith("/") ? path : `/${path}`;
    return `${this.getBaseUrl()}${cleanPath}`;
  },

  // API headers
  getApiHeaders() {
    return {
      "Content-Type": "application/json",
      "X-API-Key": "ncg_admin_2024",
    };
  },

  // Debug information
  getDebugInfo() {
    const currentConfig = this.getCurrentConfig();
    return {
      environment: this.isDevelopment ? "development" : "production",
      baseUrl: currentConfig.baseUrl,
      basePath: currentConfig.basePath,
      apiBaseUrl: currentConfig.apiBaseUrl,
      imagesBaseUrl: currentConfig.imagesBaseUrl,
      useFallbackData: this.useFallbackData,
    };
  },
};

console.log("NCG Website Config:", config.getDebugInfo());

export default config;
